import isNumber from 'lodash/isNumber';
import { Component } from 'react';
import { Text, View } from 'react-native';

import IconAdd from '../../assets/svg/IconAdd';
import IconMinus from '../../assets/svg/IconMinus';
import isExists from '../../utils/isExists';
import Touchable from '../Touchable';
import styles from './styles';

interface Props {
  initialCount?: number;
  max: number;
  min: number;
  onChange?: Function;
  onReachMax?: Function;
  // for storeCounter
  quantity?: number | string;
  disabled?: boolean;
  touchableDisabled?: boolean;
}

interface State {
  count: number;
}

export default class Counter extends Component<Props, State> {
  static defaultProps = {
    initialCount: 0,
    max: 999,
    min: 0,
    disabled: false,
    touchableDisabled: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      count: props.initialCount || 0,
    };
  }

  isReachLimit = type => {
    const { min, max } = this.props;
    const { count } = this.state;

    if (type === 'min') {
      return isExists(min) && isNumber(min) && count <= min;
    }

    if (type === 'max') {
      return isExists(max) && isNumber(max) && count >= max;
    }

    return false;
  };

  handleChange = count => {
    const { onChange } = this.props;

    if (typeof onChange === 'function') {
      onChange(count);
    }
  };

  updateCount = type => {
    const { onReachMax } = this.props;
    const count = isExists(this.props.quantity)
      ? this.props.quantity
      : this.state.count;

    if (type === 'increment') {
      if (this.isReachLimit('max')) {
        if (typeof onReachMax === 'function') {
          onReachMax();
        }

        return;
      }

      this.setState(
        {
          count: Number(count) + 1,
        },
        () => this.handleChange(this.state.count)
      );
    } else {
      if (this.isReachLimit('min')) {
        return;
      }

      this.setState(
        {
          count: Number(count) - 1,
        },
        () => this.handleChange(this.state.count)
      );
    }
  };

  increment = () => {
    this.updateCount('increment');
  };

  decrement = () => {
    this.updateCount('decrement');
  };

  renderDisabledButtonCounter = counter => (
    <View style={[styles.counter]}>
      <Text
        accessibilityRole="text"
        style={[styles.counterDisplay, styles.disabledCounterText]}
      >
        x{counter}
      </Text>
    </View>
  );

  render() {
    const { touchableDisabled, quantity, disabled } = this.props;
    const { count } = this.state;
    const counter = isExists(quantity) ? quantity : count;
    const isLimitMinTouchableDisabled =
      touchableDisabled || this.isReachLimit('min');
    const isLimitMaxTouchableDisabled =
      touchableDisabled || this.isReachLimit('max');

    if (disabled) {
      return this.renderDisabledButtonCounter(counter);
    }

    return (
      <View style={[styles.counter]}>
        <Touchable
          accessibilityRole="button"
          onPress={this.decrement}
          style={[
            styles.counterHandler,
            isLimitMinTouchableDisabled && styles.disabledHandler,
          ]}
          disabled={isLimitMinTouchableDisabled}
        >
          <IconMinus size={16} />
        </Touchable>

        <Text accessibilityRole="text" style={[styles.counterDisplay]}>
          {counter}
        </Text>

        <Touchable
          accessibilityRole="button"
          onPress={this.increment}
          style={[
            styles.counterHandler,
            isLimitMaxTouchableDisabled && styles.disabledHandler,
          ]}
          key={
            this.isReachLimit('max') ? `incrementButtonMax` : 'incrementButton'
          }
          disabled={isLimitMaxTouchableDisabled}
        >
          <IconAdd size={16} />
        </Touchable>
      </View>
    );
  }
}
